import GutXAxisFlagKey from '#components/GutXAxisFlagKey/GutXAxisFlagKey';
import { GutXAxisOrgan } from '@repo/types';
import { Icon } from '../Icon';
import { Typography } from '../Typography';
import styles from './GutXAxisBody.module.css';

/** What a hovered dot opens. Positioning is shared; only the content differs. */
export type GutXAxisHoverVariant = 'card' | 'pill';

type DotProps = {
  flagLevel: GutXAxisOrgan['flag_level'];
  displayName: GutXAxisOrgan['display_name'];
  hoverVariant?: GutXAxisHoverVariant;
};

export default function Dot({
  flagLevel,
  displayName,
  hoverVariant = 'card',
}: DotProps) {
  return (
    <span className={styles.dot}>
      {hoverVariant === 'pill' ? (
        <Typography variant='label' color='white' className={styles.pill}>
          {displayName}
        </Typography>
      ) : (
        <>
          <span className={styles.card}>
            <Typography
              variant='label'
              color='darkPurple'
              className={styles.title}
            >
              {displayName}
            </Typography>
            <GutXAxisFlagKey flagLevel={flagLevel} small />
          </span>
          <span className={styles.chevron}>
            <Icon name='chevronForward' size={'xs'} color='white' />
          </span>
        </>
      )}
    </span>
  );
}
